export { default } from "./ComparePlans";
export type { IComparePlansData, IComparePlansProps } from "./types";
